/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, DatePicker, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import UserNameLabel from '../../../components/Custom/UserNameLabel'
import OfficerName from '../../../components/Custom/OfficerName'
import OfficerSelect from '../../../components/Custom/OfficerSelect'
import AddForm from './addForm'
import SubscribeProgress from '../subscribeProgress'
import ViewPhotos from './viewPhotos'

const { RangePicker } = DatePicker
const dateFormat = 'll'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			dateRange: [],
			log_status: [],
			selectedOfficerUid: null,
			isAddFormShown: false,
			isViewPhotoShown: false,
			selectedDTR: null,
			isExporting: false,
			exportProgress: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			log_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { user_uid, barangay_uid, barangay_term_uid, user_type } = AuthStore
		const { 
			page, pageSize, sortOrder, sortName, searchText,
			dateRange = [], log_status = [], selectedOfficerUid,
			isAddFormShown, isViewPhotoShown, selectedDTR, isExporting, exportProgress
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName, log_status
		}
		if (dateRange.length > 0) {
			const startDate = moment(dateRange[0]).format('YYYY-MM-DD')
			const endDate = moment(dateRange[1]).format('YYYY-MM-DD')
			filters = Object.assign({}, filters, {
				date_start: startDate,
				date_end: endDate
			})
		}

		const statusFilter = [{ text: 'Started', value: 'Started' },
			{ text: 'Completed', value: 'Completed' },
			{ text: 'Lapsed', value: 'Lapsed' }]
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<Col md={6} sm={24}>
							{
								((dateRange.length > 0) && selectedOfficerUid && !isExporting) &&
								<button 
									type="button" 
									className="btn btn-outline-success btn-rounded waves-effect waves-light"
									onClick={() => {
										const { exportDTR } = this.props
										const params = {
											dateRange,
											officer_uid: selectedOfficerUid
										}
										exportDTR(params)
									}}
								>
									<i className='mdi mdi-file-excel'/> Export in Excel
								</button>
							}
						</Col>
						<Col md={18} sm={24}>
							<Row style={{ textAlign: 'right' }}>
								<RangePicker
									// showTime
									format={dateFormat}
									style={{ marginRight: '20px' }}
									onChange={(value) => {
										// console.log('range picker value', value)
										this.setState({ dateRange: value })
									}}
								/>
								<OfficerSelect  
									placeholder='Select Employee'
									style={{ width: 350 }}
									barangay_uid={barangay_uid}
									barangay_term_uid={barangay_term_uid}
									onChange={(value) => {
										if (value) {
											this.setState({ selectedOfficerUid: value })
										} else {
											this.setState({ selectedOfficerUid: null })
										}
									}}
								/>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Query 
							query={DTR_LOGS} 
							variables={{ 
								barangay_uid, 
								officer_uid: selectedOfficerUid, 
								searchFilter: filters 
							}}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let dtrLogs = _.has(data,'dtrLogs') ? data.dtrLogs.data : []
								dtrLogs = dtrLogs.map((dtrLog, key) => Object.assign({}, dtrLog, { key }))
								let _pagination = _.has(data, 'dtrLogs') ? data.dtrLogs.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								let columns = [{
									title: 'Employee',
									key: 'officer_uid',
									render: (record) => {
										return <OfficerName officer_uid={record.officer_uid} />
									}
								}, {
									title: 'Date',
									key: 'date',
									render: (record) => {
										let date = moment(record.log_date_in).format('ll')
										if (record.log_date_out && (date !== moment(record.log_date_out).format('ll'))) {
											date = `${date} to ${moment(record.log_date_out).format('ll')}`
										}
										return (
											<span>{date}</span>
										)
									}
								}, {
									title: 'Time In',
									key: 'log_date_in',
									render: (record) => {
										return (
											<span>{moment(record.log_date_in).format('hh:mm A')}</span>
										)
									}
								}, {
									title: 'Time Out',
									key: 'log_date_out',
									render: (record) => {
										return (
											<span>{moment(record.log_date_out).isValid() ? moment(record.log_date_out).format('hh:mm A') : '- - -'}</span>
										)
									}
								}, {
									title: 'Rendered Hours',
									key: 'duration',
									render: (record) => {
										let duration = moment.duration(moment(record.log_date_out).diff(moment(record.log_date_in)))
										duration = !_.isNaN(parseFloat(duration.asHours())) ? parseFloat(duration.asHours()).toFixed(2) + ' hour(s)' : '- - -'
										return (
											<span>{duration}</span>
										)
									}
								}, {
									title: 'Status',
									key: 'status',
									filters: statusFilter,
									render: (record) => {
										let badgeStyle = ''
										if (_.isEqual(record.status, 'Started')) {
											badgeStyle = 'badge-warning'
										} else if (_.isEqual(record.status, 'Completed')) {
											badgeStyle = 'badge-success'
										} else if (_.isEqual(record.status, 'Lapsed')) {
											badgeStyle = 'badge-danger'
										}
										return (
											<span className={`badge ${badgeStyle}`}>{record.status}</span>
										)
									}
								}, {
									title: 'Remarks',
									key: 'remarks',
									dataIndex: 'remarks'
								}, {
									title: 'Updated By',
									key: 'updated_by',
									render: (record) => {
										return <UserNameLabel user_uid={record.updated_by} />
									}
								}]
								if (_.isEqual(user_type, 'System Admin')) {
									columns.push({
										title: 'Action',
										key: 'action',
										width: 200,
										render: (record) => {
											return (
												<React.Fragment>
													<a href="#" onClick={() => this.setState({ isAddFormShown: true,  selectedDTR: record })}>Edit</a>
													<a style={{ marginLeft: 10 }} href="#" onClick={() => this.setState({ isViewPhotoShown: true,  selectedDTR: record })}>View Photos</a>
												</React.Fragment>
											)
										}
									})
								}
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'dtr' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={dtrLogs} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Col>
				{
					isAddFormShown &&
					<AddForm 
						dtr={selectedDTR}
						visible={isAddFormShown}
						onClose={() => this.setState({ isAddFormShown: false, selectedDTR: null })}
					/>
				}
				{
					isViewPhotoShown &&
					<ViewPhotos 
						visible={isViewPhotoShown}
						dtr={selectedDTR}
						onClose={() => this.setState({ isViewPhotoShown: false, selectedDTR: null })}
					/>
				}
			</Row>
		)
	}
}

const EXPORT_DTR = gql`
    mutation exportDTR($input: JSON) {
		exportDTR(input: $input)
    }
`

const DTR_LOGS = gql`
    query dtrLogs($barangay_uid: String, $officer_uid: String, $searchFilter: SearchParams) {
		dtrLogs(barangay_uid: $barangay_uid, officer_uid: $officer_uid, searchFilter: $searchFilter)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_DTR, {
		props({ mutate }) {
			return {
				exportDTR(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['dtrLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
